<lf-tooltip [help]="help" boundary="window">
  <lf-icon icon="question-circle"></lf-icon>
</lf-tooltip>
